// ',' - '.' - '!' - ';'.
export const SEARCH_PUNCTUATION_TO_IGNORE = /[,.!;]/g;

// Describes how many found words must exist to display the search action menu.
export const SEARCH_ACTION_MENU_MIN_FOUND_WORDS = 2;

export const SEARCH_BAR_PLACEHOLDER = 'Search your transcript';
